var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "web-player-feedback" }, [
    _c("div", { staticClass: "web-player-feedback__align" }, [
      !_vm.requirePassword && !_vm.title && !_vm.message
        ? _c("div", { staticClass: "stream-loader" }, [_vm._m(0)])
        : _c("div", { staticClass: "stream-feedback" }, [
            _c("h1", { staticClass: "ui-headline" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _vm._v(" "),
            _c("h2", { staticClass: "ui-title" }, [
              _vm._v(_vm._s(_vm.message)),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.requirePassword,
                    expression: "requirePassword",
                  },
                ],
                staticClass: "media-password-container",
              },
              [
                _c("ui-input", {
                  attrs: {
                    autocomplete: "new-password",
                    autofocus: "",
                    label: "Password",
                    type: "password",
                    required: "",
                  },
                  on: {
                    enter: function ($event) {
                      return _vm.onSubmitPassword(_vm.password)
                    },
                  },
                  model: {
                    value: _vm.password,
                    callback: function ($$v) {
                      _vm.password = $$v
                    },
                    expression: "password",
                  },
                }),
                _vm._v(" "),
                _c("ui-button", {
                  attrs: {
                    disabled: !_vm.isPasswordSet,
                    text: "Submit",
                    raised: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onSubmitPassword(_vm.password)
                    },
                  },
                }),
              ],
              1
            ),
          ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-progress-dots" }, [
      _c("div", { staticClass: "bounce1" }),
      _vm._v(" "),
      _c("div", { staticClass: "bounce2" }),
      _vm._v(" "),
      _c("div", { staticClass: "bounce3" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }